import React, { ReactNode, useMemo } from 'react';
import { StepNumber } from './StepNumber';
import classNames from 'classnames';
import { Typography } from '../../Typography';

export type IStepStatus = 'default' | 'active' | 'filled';

interface StepProps {
  step: number;
  title: string | ((isActive: boolean) => ReactNode);
  children: ReactNode;
  description?: string;
  status: IStepStatus;
  className?: string;
  stepClassName?: string;
}

export const Step: React.FC<StepProps> = ({
  step,
  title,
  status = 'default',
  description,
  children,
  className,
  stepClassName,
}) => {
  const isActive = useMemo(
    () => status === 'filled' || status === 'active',
    [status]
  );

  return (
    <div className={classNames(className)}>
      <div
        className={classNames('flex items-center gap-3 mb-4', stepClassName)}
      >
        <StepNumber status={status} step={step} />
        {typeof title === 'string' ? (
          <Typography
            component="h2"
            variant="h5"
            className={classNames('text-neutral-400 ', {
              '!text-neutral-900': isActive,
            })}
          >
            {title}
          </Typography>
        ) : (
          title(isActive)
        )}
      </div>
      {(status === 'active' || status === 'filled') && (
        <>
          {description && (
            <p className="text-sm text-neutral-900 mb-6">{description}</p>
          )}
          {children}
        </>
      )}
    </div>
  );
};
